/**
 * 防抖函数
 * 在窗口 resize 等高频事件中延迟执行，避免频繁触发
 * @param {Function} fn - 需要防抖的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @returns {Function} 防抖包装后的函数
 */
export function debounce(fn, delay = 300) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

/**
 * 节流函数
 * 限制函数在指定时间内最多执行一次
 * @param {Function} fn
 * @param {number} interval - 最小执行间隔（毫秒）
 * @returns {Function}
 */
export function throttle(fn, interval = 100) {
  let lastTime = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastTime >= interval) {
      lastTime = now;
      fn.apply(this, args);
    }
  };
}
